import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=5fcfec7d&scoped=true"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"
import style0 from "./Pago.vue?vue&type=style&index=0&id=5fcfec7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcfec7d",
  null
  
)

export default component.exports